import { render, staticRenderFns } from "./AIAutoDialerKPIs.vue?vue&type=template&id=08b29177&"
import script from "./AIAutoDialerKPIs.vue?vue&type=script&lang=js&"
export * from "./AIAutoDialerKPIs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports